import { useState } from "react";
import { Share2Icon } from "lucide-react";

import PlatformIcon from "@/Components/PlatformIcon.tsx";

type ShareButtonProps = {
  url?: string;
  platform?: "tiktok" | "blog" | "instagram" | "youtube";
};

const ShareButton = ({ url, platform }: ShareButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleShare = () => {
    const copyUrl = url ?? window.location.href;

    navigator.clipboard.writeText(copyUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <div className="flex items-center justify-end gap-2 w-2/12">
      <div className="relative">
        <button onClick={handleShare} className="flex items-center">
          <Share2Icon className="w-5 h-5" />
        </button>

        {copied && (
          <span className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-gray-400 text-white text-xs px-2 py-1 rounded shadow whitespace-nowrap z-[999]">
            복사됨
          </span>
        )}
      </div>

      {platform && <PlatformIcon platform={platform} />}
    </div>
  );
};

export default ShareButton;
